<template>
  <v-layout row wrap>
    <v-flex v-if="exception.message" md12>{{ $t(exception.message) }}</v-flex>
    <v-data-iterator
      :items="exception.messages"
      hide-actions
      content-tag="v-layout"
      row
      wrap
    >
      <template v-slot:item="props">
        <v-flex md12>
          <v-list dense>
            <v-list-tile>
              <v-list-tile-avatar v-if="props.item.level">
                <v-icon medium color="red" v-if="props.item.level === 'ERROR'"
                  >error</v-icon
                >
                <v-icon medium color="orange" v-if="props.item.level === 'WARN'"
                  >warning</v-icon
                >
                <v-icon medium color="blue" v-if="props.item.level === 'INFO'"
                  >info</v-icon
                >
              </v-list-tile-avatar>
              <v-list-tile-content class="non-uppercase"
                >{{
                  $t(
                    (i18nPrefix ? i18nPrefix + '.' : '') + props.item.errorCode,
                  )
                }}
                {{ props.item.fieldName ? ' : ' + props.item.fieldName : '' }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </template>
    </v-data-iterator>
  </v-layout>
</template>

<script>
import _ from 'lodash';
const NAMESPACE = 'exception';

export default {
  provide() {
    return {
      namespace: NAMESPACE,
      $vroot: this.$v,
    };
  },
  props: {
    value: {
      type: Object,
      required: false,
    },
    i18nPrefix: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {},
  watch: {
    value(val) {
      if (val == null || _.isEmpty(val)) {
        this.exception = Object.assign({}, this.emptyException);
      } else {
        Object.assign(this.exception, val);
      }
    },
  },
  data() {
    return {
      exception: {
        message: null,
        messages: [
          {
            level: null,
            errorCode: '',
            fieldName: null,
          },
        ],
      },
      emptyException: {
        message: null,
        messages: [
          {
            level: null,
            errorCode: '',
            fieldName: null,
          },
        ],
      },
    };
  },
  created() {
    this.exception = Object.assign({}, this.emptyException);
  },
  methods: {},
  validations: {},
};
</script>

<style scoped>
.non-uppercase {
  font-weight: bold !important;
  text-transform: none;
}
</style>
